<!-- <app-scope-report
  [mp4StudyFiles]="mp4StudyFiles$ | async"
  [pdfStudyFiles]="pdfStudyFiles$ | async"
  (createStudyFile)="createStudyFile($event)"
>
</app-scope-report> -->
<div class="flex justify-content-end mt-4">
  <!--<button class="btn btn-danger mr-6"
          tabindex="-1"
          (click)="cancelStudyAndDeleteFiles()"
          [disabled]="!(allStudyFiles$ | async)?.length">
    <i class="fa fa-times"></i> Cancel & Delete Files
  </button>-->

  <button class="btn btn-danger mr-6"
          tabindex="-1"
          (click)="cancelStudySubmission()"
          [disabled]="!(allStudyFiles$ | async)?.length">
    <i class="fa fa-times"></i> Cancel Submission
  </button>

  <button class="btn btn-success" (click)="openUploadModal()">
    <i class="fa fa-plus"></i> Upload files
  </button>
</div>
<div>
  <app-asset-table [studyFiles]="filterByMember(mp4StudyFiles$ | async)"
                   [conversionLogMap]="conversionLogMap"
                   [headingText]="'VIDEOS'"
                   [required]="saleSettings?.declareScopeVideo"
                   (openButtonClicked)="openVideoModal($event)"
                   (deleteFileClicked)="deleteStudyFile($event)"></app-asset-table>

  <study-docs-list-table [headingText]="'DOCUMENTS'"
                         [isReadOnly]="true"
                         [isInUpload]="true"
                         [statuses]="statuses$ | async"
                         [openButtonText]="'Open Images in Viewer'"
                         [studyFiles]="filterByMember(pdfStudyFiles$ | async)"
                         (deleteFileClicked)="deleteStudyFile($event)"
                         [required]="saleSettings?.declarePdfReports"></study-docs-list-table>
</div>

<ng-container *ngIf="(unmatchedStudyFiles$ | async)?.length">
  <app-unmatched-xrays [headingText]="'X-RAY IMAGES'"
                       [studyFiles]="filterByMember(unmatchedStudyFiles$ | async)"
                       [mediaGroups]="mediaGroups$ | async"
                       [mediaCategories]="mediaCategories$ | async"
                       (changeMediaCategory)="updateStudyFileCategory($event)"
                       (uploadAsAdditional)="updateStudyFileIsAdditional($event)"
                       (deleteStudyFile)="deleteStudyFile($event)"></app-unmatched-xrays>
</ng-container>

<!--<ng-container *ngIf="(multipleStudyFiles$ | async)?.length">
  <app-multiple-xrays
    [studyFiles]="filterByMember(multipleStudyFiles$ | async)"
    [mediaGroups]="mediaGroups$ | async"
    [mediaCategories]="mediaCategories$ | async"
    (changeMediaCategory)="updateStudyFileCategory($event)"
    (uploadAsAdditional)="updateStudyFileIsAdditional($event)"
    (deleteStudyFile)="deleteStudyFile($event)"
    (useImage)="submitStudyFilesAsAdditional($event)"
  >
  </app-multiple-xrays>
</ng-container>-->
<!-- <ng-container *ngIf="(missingMediaCategories$ | async)?.length">
  <app-missing-xrays
    [studyFiles]="matchedStudyFiles$ | async"
    [mediaGroups]="mediaGroups$ | async"
    [mediaCategories]="mediaCategories$ | async"
    (changeMediaCategory)="updateStudyFileCategory($event)"
    (uploadAsAdditional)="updateStudyFileIsAdditional($event)"
    (deleteStudyFile)="deleteStudyFile($event)"
    (createStudyFile)="createStudyFileWithMediaCategoryId($event)"
    (updateStudyFileStatus)="updateStudyFileStatus($event)"
  ></app-missing-xrays>
</ng-container> -->

<!--<app-matched-xrays [studyFiles]="filterByMember(xrayAllStudyFiles$ | async)"
                   [mediaGroups]="mediaGroupsAll$ | async"
                   [xraysMediaGroups]="xraysMediaGroups"
                   [saleId]="saleId"
                   [horseId]="horseId"
                   [studyId]="studyId"
                   [saleName]="saleName"
                   [horseName]="horseName"
                   [lot]="lot"
                   [headingText]="'X-RAY IMAGES'"
                   [mediaCategories]="mediaCategories$ | async"
                   [filterMediaCategories]="filteredMediaCategories$ | async"
                   [activeStudy]="activeSaleHorseStudy$ | async"
                   (changeMediaCategory)="updateStudyFileCategory($event)"
                   (uploadAsAdditional)="updateStudyFileIsAdditional($event)"
                   (deleteStudyFile)="deleteStudyFile($event)"
                   (createStudyFile)="createStudyFileCheck($event)"></app-matched-xrays>-->


<app-categorized-xrays [studyFiles]="filterByMember(xrayAllStudyFiles$ | async)"
                   [mediaGroups]="mediaGroupsAll$ | async"
                   [xraysMediaGroups]="xraysMediaGroups"
                   [saleId]="saleId"
                   [horseId]="horseId"
                   [studyId]="studyId"
                   [saleName]="saleName"
                   [horseName]="horseName"
                   [lot]="lot"
                   [headingText]="'X-RAY IMAGES'"
                   [mediaCategories]="mediaCategories$ | async"
                   [filterMediaCategories]="filteredMediaCategories$ | async"
                   [activeStudy]="activeSaleHorseStudy$ | async"
                   (changeMediaCategory)="updateStudyFileCategory($event)"
                   (uploadAsAdditional)="updateStudyFileIsAdditional($event)"
                   (deleteStudyFile)="deleteStudyFile($event)"
                   (createStudyFile)="createStudyFileCheck($event)"></app-categorized-xrays>

<!--<app-additional-xrays
  [studyFiles]="filterByMember(additionalStudyFiles$ | async)"

  [mediaGroups]="mediaGroups$ | async"
  [saleId]="saleId"
  [horseId]="horseId"
  [studyId]="studyId"
  [saleName]="saleName"
  [horseName]="horseName"
  [mediaCategories]="mediaCategories$ | async"
  (changeMediaCategory)="updateStudyFileCategory($event)"
  (uploadAsAdditional)="updateStudyFileIsAdditional($event)"
  (deleteStudyFile)="deleteStudyFile($event)"
  (createStudyFiles)="createStudyFileCheck($event)"
></app-additional-xrays>-->

<div class="section">
  <div class="row justify-content-end me-2" *ngIf="errorMessages">
    <div class="col-auto">
      <div class="warning-panel" >
        <span class="icon">⚠️</span>
        <span class="message" style="white-space:pre-line;">
          {{ errorMessages }}
        </span>
        <button class="dismiss-btn" (click)="hideWarningAlert()">✖</button>
      </div>
    </div>
  </div>
 
  
  <div class="button-wrapper flex justify-content-end">
    <button type="button"
            class="btn btn-outline-primary me-2"
            (click)="closeModal()">
      Close
    </button>
    <button type="button"
            class="btn btn-primary"
            [disabled]="!saleSettings?.isSubmissionAllowed"
            (click)="submitStudy()">
      Submit
    </button>
  </div>
  <div class="flex justify-content-end">
    <p *ngIf="!saleSettings?.isSubmissionAllowed"
       class="small-text text-warning">
      You cannot submit these files as you are not within the submission period
    </p>
  </div>
</div>
